export default {
  en: {
    posNoun: 'Noun',
    posVerb: 'Verb',
    posAdjective: 'Adjective',
    posAdverb: 'Adverb',
    posPronoun: 'Pronoun',
    posPreposition: 'Preposition',
    posConjunction: 'Conjunction',
    posInterjection: 'Interjection',
    posPhrase: 'Phrase',
    posArticle: 'Article',
    posDeterminer: 'Determiner',
    posModalVerb: 'Modal verb',
    posNumber: 'Number',
    statusNew: 'New',
    statusLearning: 'Learning',
    statusKnown: 'Known',
    statusMastered: 'Mastered',
  },
  ru: {
    posNoun: 'Сущ.',
    posVerb: 'Глагол',
    posAdjective: 'Прил.',
    posAdverb: 'Нареч.',
    posPronoun: 'Мест.',
    posPreposition: 'Предл.',
    posConjunction: 'Союз',
    posInterjection: 'Межд.',
    posPhrase: 'Фраза',
    posArticle: 'Артикль',
    posDeterminer: 'Определитель',
    posModalVerb: 'Модальный гл.',
    posNumber: 'Числит.',
    statusNew: 'Новое',
    statusLearning: 'Учится',
    statusKnown: 'Знаю',
    statusMastered: 'Выучено',
  },
};
